<app-report-shell
  [user]="user"
  [currentTime]="''"
  [sidebarCollapsed]="sidebarCollapsed"
  [mobileSidebarOpen]="mobileSidebarOpen"
  (menuToggle)="handleMenuToggle()"
  (closeMobileSidebar)="closeMobileSidebar()"
>
  <main class="master-data-page">
    <section class="master-data-page__panel app-card">
      <div class="master-data-page__panel-header">
        <div class="master-data-page__heading-copy">
          <h2 class="app-title-serif">Market Data</h2>
        </div>

        <button
          type="button"
          class="app-button app-button--primary master-data-page__export-button"
          [disabled]="isLoading || isExporting"
          (click)="handleExportToExcel()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 3v10"></path>
            <path d="m8 9 4 4 4-4"></path>
            <path d="M5 17v2h14v-2"></path>
          </svg>
          <span>{{ isExporting ? 'Exporting...' : 'Export to Excel' }}</span>
        </button>
      </div>

      <div class="master-data-page__panel-body">
        <div class="master-data-page__filters-row">
          <form class="master-data-filters" [formGroup]="filtersForm">
            <label class="app-form-field master-data-filters__field">
              <span class="app-form-label">Data Frequency</span>
              <select class="app-form-input master-data-filters__input" formControlName="data_frequency">
                @for (option of frequencyOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>

            <label class="app-form-field master-data-filters__field">
              <span class="app-form-label">From Date</span>
              @if (isMonthlyFrequency()) {
                <mat-form-field class="master-data-filters__material-field" appearance="outline" subscriptSizing="dynamic">
                  <input
                    matInput
                    readonly
                    [matDatepicker]="fromMonthPicker"
                    [(ngModel)]="fromMonthPickerDate"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <mat-datepicker-toggle matSuffix [for]="fromMonthPicker"></mat-datepicker-toggle>
                  <mat-datepicker
                    #fromMonthPicker
                    startView="multi-year"
                    (monthSelected)="onFromMonthSelected($event, fromMonthPicker)"
                  ></mat-datepicker>
                </mat-form-field>
              } @else {
                @if (isBsDateMode) {
                  <div class="master-data-filters__bs-date-shell">
                    <button type="button" class="app-form-input master-data-filters__input master-data-filters__date-display" [attr.aria-expanded]="bsCalendarOpen && activeBsDateControl === 'from_date'" aria-haspopup="dialog" (click)="openBsDatePicker('from_date')">{{ getFromDateValue() }}</button>
                    @if (bsCalendarOpen && activeBsDateControl === 'from_date') {
                      <dialog class="master-data-bs-calendar" open aria-label="Nepali calendar date picker" appClickOutside (appClickOutside)="closeBsDatePicker()" (mousedown)="$event.stopPropagation()"><div class="master-data-bs-calendar__header"><button type="button" aria-label="Previous month" (click)="shiftBsCalendarMonth(-1)">‹</button><strong>{{ bsCalendarMonth?.bs_month_name || 'Nepali Calendar' }} {{ bsCalendarMonth?.bs_year || '' }}</strong><button type="button" aria-label="Next month" (click)="shiftBsCalendarMonth(1)">›</button></div><div class="master-data-bs-calendar__weekdays">@for (weekday of bsCalendarWeekdays; track weekday) { <span>{{ weekday }}</span> }</div>@if (bsCalendarLoading) { <div class="master-data-bs-calendar__loading">Loading calendar...</div> } @else { <div class="master-data-bs-calendar__grid">@for (cell of (bsCalendarMonth?.cells || []); track cell.bs_date) { <button type="button" [class.is-muted]="!cell.in_current_month" [class.is-selected]="cell.is_selected" [class.is-today]="cell.is_today" (click)="selectBsCalendarCell(cell)">{{ cell.bs_date_label }}</button> }</div> }</dialog>
                    }
                  </div>
                } @else {
                  <input class="app-form-input master-data-filters__input" type="date" formControlName="from_date" [max]="getMaxToDate()" />
                }
              }
            </label>

            <label class="app-form-field master-data-filters__field">
              <span class="app-form-label">To Date</span>
              @if (isMonthlyFrequency()) {
                <mat-form-field class="master-data-filters__material-field" appearance="outline" subscriptSizing="dynamic">
                  <input
                    matInput
                    readonly
                    [matDatepicker]="toMonthPicker"
                    [(ngModel)]="toMonthPickerDate"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <mat-datepicker-toggle matSuffix [for]="toMonthPicker"></mat-datepicker-toggle>
                  <mat-datepicker
                    #toMonthPicker
                    startView="multi-year"
                    (monthSelected)="onToMonthSelected($event, toMonthPicker)"
                  ></mat-datepicker>
                </mat-form-field>
              } @else {
                @if (isBsDateMode) {
                  <div class="master-data-filters__bs-date-shell">
                    <button type="button" class="app-form-input master-data-filters__input master-data-filters__date-display" [attr.aria-expanded]="bsCalendarOpen && activeBsDateControl === 'to_date'" aria-haspopup="dialog" (click)="openBsDatePicker('to_date')">{{ getToDateValue() }}</button>
                    @if (bsCalendarOpen && activeBsDateControl === 'to_date') {
                      <dialog class="master-data-bs-calendar" open aria-label="Nepali calendar date picker" appClickOutside (appClickOutside)="closeBsDatePicker()" (mousedown)="$event.stopPropagation()"><div class="master-data-bs-calendar__header"><button type="button" aria-label="Previous month" (click)="shiftBsCalendarMonth(-1)">‹</button><strong>{{ bsCalendarMonth?.bs_month_name || 'Nepali Calendar' }} {{ bsCalendarMonth?.bs_year || '' }}</strong><button type="button" aria-label="Next month" (click)="shiftBsCalendarMonth(1)">›</button></div><div class="master-data-bs-calendar__weekdays">@for (weekday of bsCalendarWeekdays; track weekday) { <span>{{ weekday }}</span> }</div>@if (bsCalendarLoading) { <div class="master-data-bs-calendar__loading">Loading calendar...</div> } @else { <div class="master-data-bs-calendar__grid">@for (cell of (bsCalendarMonth?.cells || []); track cell.bs_date) { <button type="button" [class.is-muted]="!cell.in_current_month" [class.is-selected]="cell.is_selected" [class.is-today]="cell.is_today" (click)="selectBsCalendarCell(cell)">{{ cell.bs_date_label }}</button> }</div> }</dialog>
                    }
                  </div>
                } @else {
                  <input class="app-form-input master-data-filters__input" type="date" formControlName="to_date" [min]="getMinFromDate()" />
                }
              }
            </label>

            <label class="app-form-field master-data-filters__field">
              <span class="app-form-label">Exchange</span>
              <details class="master-data-filters__multi-select">
                <summary class="master-data-filters__multi-select-summary">{{ getSelectedExchangeLabel() }}</summary>
                <div class="master-data-filters__multi-select-menu">
                  @for (option of exchangeOptions; track option.value) {
                    <label class="master-data-filters__multi-select-option">
                      <input type="checkbox" [checked]="isExchangeSelected(option.value)" (change)="toggleExchangeSelection(option.value, $event)" />
                      <span>{{ option.label }}</span>
                    </label>
                  }
                </div>
              </details>
            </label>

            <label class="app-form-field master-data-filters__field">
              <span class="app-form-label">Product</span>
              <details class="master-data-filters__multi-select">
                <summary class="master-data-filters__multi-select-summary">{{ getSelectedProductLabel() }}</summary>
                <div class="master-data-filters__multi-select-menu">
                  @for (option of productOptions; track option.value) {
                    <label class="master-data-filters__multi-select-option">
                      <input type="checkbox" [checked]="isProductSelected(option.value)" (change)="toggleProductSelection(option.value, $event)" />
                      <span>{{ option.label }}</span>
                    </label>
                  }
                </div>
              </details>
            </label>

            <div class="master-data-filters__actions">
              <button type="button" class="app-button app-button--secondary app-filter-actions__button" (click)="clearFilters()">
                Clear
              </button>
            </div>
          </form>
        </div>


        @if (errorMessage) {
          <div class="master-data-page__error">{{ errorMessage }}</div>
        }

        <div class="master-data-page__table-wrap app-table-scroll app-scrollbar-x">
          @if (isBlockMode()) {
            <table class="master-data-table">
              <colgroup>
                <col class="master-data-table__col--block" />
                <col class="master-data-table__col--time" />
                @for (column of leafColumns; track trackByLeafColumn($index, column)) {
                  <col class="master-data-table__col--leaf" />
                }
              </colgroup>
              <thead>
                <tr>
                  <th class="master-data-table__sticky-column master-data-table__sticky-column--header master-data-table__block-column" scope="col" rowspan="4">S.No.</th>
                  <th class="master-data-table__time-column master-data-table__time-column--header" scope="col" rowspan="4">Time</th>
                  @for (group of dateGroups; track trackByDateGroup($index, group)) {
                    <th
                      scope="colgroup"
                      [attr.colspan]="group.span"
                      class="master-data-table__header-band master-data-table__header-band--date master-data-table__header-band--group-end"
                    >
                      {{ group.label }}
                    </th>
                  }
                </tr>
                <tr>
                  @for (group of exchangeGroups; track trackByExchangeGroup($index, group)) {
                    <th
                      scope="colgroup"
                      [attr.colspan]="group.span"
                      class="master-data-table__header-band master-data-table__header-band--exchange master-data-table__header-band--group-end"
                    >
                      {{ group.label }}
                    </th>
                  }
                </tr>
                <tr>
                  @for (group of productGroups; track trackByProductGroup($index, group)) {
                    <th
                      scope="colgroup"
                      [attr.colspan]="group.span"
                      class="master-data-table__header-band master-data-table__header-band--product master-data-table__header-band--group-end"
                    >
                      {{ group.label }}
                    </th>
                  }
                </tr>
                <tr>
                  @for (column of leafColumns; track trackByLeafColumn($index, column)) {
                    <th scope="col" [class]="'master-data-table__metric-header ' + getColumnMetricClass(column)">
                      <span>{{ column.metric }}</span>
                      <small>{{ getMetricUnit(column.metric) }}</small>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td [attr.colspan]="getEmptyStateColspan()" class="master-data-page__empty-state">Loading master data...</td>
                  </tr>
                } @else if (blockRows.length && leafColumns.length) {
                  @for (block of blockRows; track trackByBlock($index, block)) {
                    <tr class="master-data-table__body-row">
                      <th class="master-data-table__sticky-column master-data-table__sticky-column--body" scope="row">
                        {{ getBlockLabel(block) }}
                      </th>
                      <td class="master-data-table__time-column master-data-table__time-column--body">
                        {{ getBlockTime(block) }}
                      </td>
                      @for (column of leafColumns; track trackByLeafColumn($index, column)) {
                        <td [class]="'master-data-table__cell ' + getColumnMetricClass(column)">
                          {{ getCellText(block, column) }}
                        </td>
                      }
                    </tr>
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="getEmptyStateColspan()" class="master-data-page__empty-state">
                      No master data found for the selected filters
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <table class="master-data-table master-data-table--period">
              <colgroup>
                <col class="master-data-table__col--block" />
                <col class="master-data-table__col--period-label" />
                @for (column of periodLeafColumns; track trackByLeafColumn($index, column)) {
                  <col class="master-data-table__col--leaf" />
                }
              </colgroup>
              <thead>
                <tr>
                  <th class="master-data-table__sticky-column master-data-table__sticky-column--header master-data-table__block-column" scope="col" rowspan="3">S.No.</th>
                  <th class="master-data-table__sticky-column master-data-table__sticky-column--header master-data-table__period-column" scope="col" rowspan="3">
                    {{ getRowAxisTitle() }}
                  </th>
                  @for (group of periodExchangeGroups; track trackByExchangeGroup($index, group)) {
                    <th
                      scope="colgroup"
                      [attr.colspan]="group.span"
                      class="master-data-table__header-band master-data-table__header-band--exchange master-data-table__header-band--group-end"
                    >
                      {{ group.label }}
                    </th>
                  }
                </tr>
                <tr>
                  @for (group of periodProductGroups; track trackByProductGroup($index, group)) {
                    <th
                      scope="colgroup"
                      [attr.colspan]="group.span"
                      class="master-data-table__header-band master-data-table__header-band--product master-data-table__header-band--group-end"
                    >
                      {{ group.label }}
                    </th>
                  }
                </tr>
                <tr>
                  @for (column of periodLeafColumns; track trackByLeafColumn($index, column)) {
                    <th scope="col" [class]="'master-data-table__metric-header ' + getColumnMetricClass(column)">
                      <span>{{ column.metric }}</span>
                      <small>{{ getMetricUnit(column.metric) }}</small>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td [attr.colspan]="getEmptyStateColspan()" class="master-data-page__empty-state">Loading master data...</td>
                  </tr>
                } @else if (rowLabels.length && periodLeafColumns.length) {
                  @for (row of rowLabels; track trackByRowLabel($index, row)) {
                    <tr class="master-data-table__body-row">
                      <th class="master-data-table__sticky-column master-data-table__sticky-column--body master-data-table__block-column" scope="row">
                        {{ $index + 1 }}
                      </th>
                      <th class="master-data-table__sticky-column master-data-table__sticky-column--body master-data-table__period-column" scope="row">
                        {{ row.label }}
                      </th>
                      @for (column of periodLeafColumns; track trackByLeafColumn($index, column)) {
                        <td [class]="'master-data-table__cell ' + getColumnMetricClass(column)">
                          {{ getPeriodCellText(row.key, column) }}
                        </td>
                      }
                    </tr>
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="getEmptyStateColspan()" class="master-data-page__empty-state">
                      No master data found for the selected filters
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    </section>
  </main>
</app-report-shell>
